<template>
    <v-layout align-center justify-center class="upload_bg">
         <v-toolbar fixed flat class="transparent" style="color:white;">
            Attendance Upload
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn :disabled="uploading" dark flat @click="closeDialog">Close</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm7>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>
            <v-alert :value="true" color="info" icon="info" outline>
                {{uploadReminder}}
            </v-alert>
            <v-alert v-if="overwriteExistingAttendance" :value="true" color="warning" icon="warning" outline>
                <b>IMPORTANT.</b> This will overwrite any existing attendance records that match the uploaded data.
            </v-alert>
            <v-alert v-if="uploading" :value="true" color="info" icon="info" outline>
                Uploading...
            </v-alert>
            <div class="text-xs-center">
                <v-card class="elevation-1" >
                    <v-toolbar flat height="45px">
                        <v-switch
                            v-model="overwriteExistingAttendance"
                            label="Overwrite Existing Attendance"
                            color="primary"
                            hide-details
                            style="margin:0px 0px 5px 5px;"
                            @change="setOverwriteExistingAttendance"
                        ></v-switch>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <vue-dropzone ref="myVueDropzone" 
                        style="height:270px;padding:0px 50px 0px 50px;"
                        id="dropzone" 
                        v-show="showUpload"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="uploadSuccess"
                        v-on:vdropzone-file-added="fileAdded"
                        ></vue-dropzone>
                </v-card>
            </div>
         </v-flex> 
     </v-layout>
 </template>
 <script>

import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import pageKeys from '@/common/pagekeys'

export default {
    name: 'upload-attendance',
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            userId: 0,   
            img: null,   
            showUpload: true,      
            dropzoneOptions: {                    
                url: `${axios.defaults.baseURL}AttendanceUpload/upload`,    
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "page_key": pageKeys.attendance_upload,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                params: {
                    cutOffId: null,
                    teamId: null,
                    overwriteExistingAttendance: false
                },
                addRemoveLinks: true,
                dictDefaultMessage: "<br><b class='headline'><u>Drag your file or click here to browse</u><b><br><br><p class='caption'>Maximum 5MB per file.<br>Accepted files types: excel (*.xlsx, *.xls)</p>",
                maxFiles: 1,
                acceptedFiles: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
                maxFilesize: 5,   //5mb
            },
            uploadReminder: 'Make sure to use the Upload Template file for the selected CutOff period.',
            uploading: false,
            error: false,
            errorMessage: '',
            selectedCutoffId: null,
            overwriteExistingAttendance: false
        }
    },
    methods: {
        setOverwriteExistingAttendance(data) {
            this.dropzoneOptions.params.overwriteExistingAttendance = this.overwriteExistingAttendance
        },
        setData(selectedCutoffId){
            this.uploading = false
            this.selectedCutoffId = selectedCutoffId
            this.dropzoneOptions.params.cutOffId = selectedCutoffId
            this.dropzoneOptions.params.teamId = this.$store.state.selectedTeamId
        },
        fileAdded(file) {
            this.uploading = true
        },
        uploadSuccess(file, response) {
            this.error = false
            this.uploading = false
            this.$emit('send', response)
            this.$emit('update:dialogUpload', false)
        },
        closeDialog() {
            this.showUpload=true
            this.$emit('update:dialogUpload', false)
        }
    },
    created() {}
}
 </script>
 <style scoped>
.upload_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
}
 </style>